import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { AppTile, AppTileGridSkeleton, AppTilesGridContainer } from '@atlassian/mpac-app-tile';
import { breakpointValues, PartialOutageError, useResponsiveBreakpoint } from '@atlassian/mpac-primitives';
import { useEnvironment, useSource } from '@atlassian/mpac-utils';
import React from 'react';
import { useHomepageAnalytics } from '../../hooks/useHomepageAnalytics';
import { SECTIONS } from '../../hooks/useHomepageAnalytics/constants';
import { TEST_IDS } from '../../testids';
import { RegularSection, RegularSectionSkeleton } from '../RegularSection';
import { jsx as _jsx } from "react/jsx-runtime";
export function EnterpriseAppsSectionSkeleton(_ref) {
  let {
    tileCount
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    "data-testid": TEST_IDS.ENTERPRISE_SECTION_SKELETON,
    children: /*#__PURE__*/_jsx(RegularSectionSkeleton, {
      children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
        children: /*#__PURE__*/_jsx(AppTileGridSkeleton, {
          tileCount: tileCount
        })
      })
    })
  });
}
export function EnterpriseAppsSection(_ref2) {
  let {
    isLoading,
    isError,
    data
  } = _ref2;
  const source = useSource();
  const environment = useEnvironment();
  const {
    value: breakpoint
  } = useResponsiveBreakpoint();
  const isMobile = breakpoint < breakpointValues.sm;
  const isTablet = breakpoint < breakpointValues.md && breakpoint >= breakpointValues.sm;
  const {
    trackTileClick,
    trackHomeScreenErrorState
  } = useHomepageAnalytics();
  const handleTileClick = (app, title, index) => {
    const tileClickEventData = {
      app,
      sectionTitle: title,
      index,
      hideDescription: isMobile
    };
    trackTileClick(tileClickEventData);
  };
  if (isLoading) {
    const tileCount = isMobile ? 3 : isTablet ? 4 : 6;
    return /*#__PURE__*/_jsx(UFOLoadHold, {
      name: SECTIONS.ENTERPRISE,
      children: /*#__PURE__*/_jsx(EnterpriseAppsSectionSkeleton, {
        tileCount: tileCount
      })
    });
  }
  if (isError) {
    trackHomeScreenErrorState(SECTIONS.ENTERPRISE);
    return /*#__PURE__*/_jsx(PartialOutageError, {});
  }
  if (data) {
    const {
      title,
      description,
      navigationUrl,
      apps
    } = data;
    let appsToRender = apps;
    if (isMobile) {
      appsToRender = apps.slice(0, 3);
    } else if (isTablet) {
      appsToRender = apps.slice(0, 4);
    }
    return /*#__PURE__*/_jsx(RegularSection, {
      title: title,
      description: description,
      navigationUrl: navigationUrl,
      children: /*#__PURE__*/_jsx(AppTilesGridContainer, {
        children: appsToRender.map((app, index) => /*#__PURE__*/_jsx(AppTile, {
          tileData: app,
          environment: environment,
          source: source,
          hideTagline: isMobile,
          onTileClick: () => handleTileClick(app, title, index)
        }, app.addonKey))
      })
    });
  } else {
    return null;
  }
}